import { createContext } from "react";

export const LeagueContext = createContext({
  leagueCode: "",
  checkboxCheckedStates: [],
  triggerClassicPublicLeagueRefetch: false,
  isLeagueMarketingPage: false,
  leagueInfoSuccessData: {},
  updateLeagueCode: () => {},
  updateCheckboxCheckedStates: () => {},
  updateTriggerClassicPublicLeagueRefetch: () => {},
  updateIsLeagueMarketingPage: () => {},
  updateLeagueInfoSuccessData: () => {},
});
